import React from "react";
import { CompatibilityLisContainer } from "./style";

const CompatibilityListBySign = ({ items, title }) => {
  return (
    <CompatibilityLisContainer>
      <h2>{title}</h2>
      <div className="compatibility-grid">
        {items.map(({ url, label, img, alt, textLink }, index) => (
          <a
            key={index}
            className="compatibility-link"
            href={url}
            aria-label={label}
          >
            <div className="compatibility-item">
              <img
                width="50"
                height="50"
                loading="lazy"
                alt={alt}
                src={img}
              />
              <span>{textLink}</span>
            </div>
          </a>
        ))}
      </div>
    </CompatibilityLisContainer>
  );
};

export default CompatibilityListBySign;
